export const docTypeList = [
  {type: 'ocr', value: '1', label: '표준계약서', searchKeyword: '', show: false, templateType: null},
  {type: 'ocr', value: '2', label: '양도양수', searchKeyword: '이전사업자', show: true, templateType: null},
  {type: 'ocr', value: '3', label: '설치확정서', searchKeyword: '설치확정서', show: false, templateType: null},
  {type: 'template', value: '4', label: '서비스이용일확정서', searchKeyword: '서비스이용일 확정서', show: true, templateType: 'service_date_confirmation'},
];

// 서비스이용일확정서 템플릿 라벨명
export const confirmedDateLabels = [
  {name: '기존작성일', dataLabel: 'Contract_writeDate'},
  {name: '일련번호', dataLabel: 'Contract_number'},
  {name: '계약시작일', dataLabel: 'Contract_startDate'},
  {name: '계약만료일', dataLabel: 'Contract_endDate'},
  {name: '서비스시작일', dataLabel: 'Service_startDate'},
  {name: '서비스만료일', dataLabel: 'Service_endDate'},
  {name: '발송일자', dataLabel: 'Send_date'},
]

export const config = {
  docTypeList,
  confirmedDateLabels,
};
